import React, { useMemo, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { hideLoading, setFromLogin, showLoading } from 'app/store/slices/settings';
import { logIn, logOut } from 'app/store/slices/user';
import { INTERNAL_CONTEXT, URLS } from 'app/config/urls';
import auth from 'app/api/auth';
import notification from 'app/config/notification';
import { injectIntl } from 'react-intl';
import { REPORT_MAP } from '../../internalPages/Reports/config/reports-config';

const MenuDev = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { intl } = props;

    const userCredentials = {
        adminEmpresas: {
            username: '02539301541',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
        diretorEmpresas: {
            username: '19285108504',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
        adminVeiculos: {
            username: '78466083553',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
        diretorVeiculos: {
            username: '21741824591',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
        adminLicencas: {
            username: '24464171591',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
        diretorLicencas: {
            username: '21741824591',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
        vistoriadora: {
            username: '95454312000181',
            password: '5of78l@n2024', // password: '1',
            isInternal: false,
        },
        adminLinhas: {
            username: '70027242587',
            password: '5of78l@n2024', // password: '1',
            isInternal: true,
        },
    };

    const isLogged = useMemo(() => {
        return !!auth.getToken();
    }, []);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const goTo = (url) => {
        history.push(url);
        handleClose();
    };

    const handleLogOut = async (type) => {
        handleClose();
        dispatch(showLoading());
        dispatch(setFromLogin(false));
        await logOut(dispatch);
        history.push(URLS.LOGIN);
        dispatch(hideLoading());
    };

    const login = async (type) => {
        dispatch(showLoading());
        try {
            handleClose();
            const credentials = userCredentials[type];
            const response = await logIn(credentials, dispatch);
            if (response) {
                history.push(credentials.isInternal ? INTERNAL_CONTEXT : '/');
            } else {
                notification(intl.formatMessage({ id: 'MESSAGES.LOGIN.USER_NOT_FOUND' }), {
                    toastId: 'USER_NOT_FOUND',
                    type: 'error',
                });
            }
        } catch (err) {}
        dispatch(hideLoading());
    };

    return (
        <div>
            <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: 60 * 4.5,
                        width: '300px',
                    },
                }}>
                {!isLogged && <MenuItem onClick={() => login('adminEmpresas')}>Login admin empresas</MenuItem>}
                {!isLogged && <MenuItem onClick={() => login('diretorEmpresas')}>Login diretor empresas</MenuItem>}
                {!isLogged && <MenuItem onClick={() => login('adminVeiculos')}>Login admin veículos</MenuItem>}
                {!isLogged && <MenuItem onClick={() => login('diretorVeiculos')}>Login diretor veículos</MenuItem>}
                {!isLogged && <MenuItem onClick={() => login('adminLicencas')}>Login admin licenças</MenuItem>}
                {!isLogged && <MenuItem onClick={() => login('diretorLicencas')}>Login diretor licenças</MenuItem>}
                {!isLogged && <MenuItem onClick={() => login('vistoriadora')}>Login vistoriadora</MenuItem>}

                {!isLogged && <MenuItem onClick={() => login('adminLinhas')}>Login admin Linhas</MenuItem>}

                {isLogged && <MenuItem onClick={() => goTo(INTERNAL_CONTEXT)}>Home Interno</MenuItem>}
                {isLogged && <MenuItem onClick={() => goTo('/')}>Home Externo</MenuItem>}
                {isLogged && (
                    <MenuItem onClick={() => goTo(`${INTERNAL_CONTEXT}/lines?strip=false`)}>
                        Gestor de linhas SLIC
                    </MenuItem>
                )}
                {isLogged && (
                    <MenuItem onClick={() => goTo(`${INTERNAL_CONTEXT}/strip/lines`)}>Gestor de linhas STRIP</MenuItem>
                )}
                {isLogged &&
                    Object.entries(REPORT_MAP).map((entry) => {
                        const [cod, r] = entry;
                        return (
                            <MenuItem key={cod} onClick={() => goTo(`${URLS.REPORTS}?type=${cod}`)}>
                                Relatório {r.title}
                            </MenuItem>
                        );
                    })}
                {isLogged && <MenuItem onClick={handleLogOut}>Sair</MenuItem>}
            </Menu>
        </div>
    );
};
export default injectIntl(MenuDev);
